import $ from 'jquery';

function escapeHtml(str) {
  // Cannot use `!str` — a score of 0 is a real, valid value we need to render.
  if (str === null || str === undefined) return '';
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function scoreBand(score){
  if (score == null || score === '') return null;
  var s = Number(score);
  if (isNaN(s)) return null;
  if (s >= 75) return 'strong';
  if (s >= 50) return 'moderate';
  return 'weak';
}

function bandLabel(band){
  // Map to i18n keys defined under ai.score_band_* — fall back gracefully.
  if (!band) return '';
  var map = { strong: 'Strong', moderate: 'Moderate', weak: 'Weak' };
  return map[band] || '';
}
// Track initialization to prevent duplicate event listeners
let initialized = false;

function init(){
  // Prevent duplicate initialization
  if (initialized) return;
  initialized = true;

  // Use namespaced events for potential cleanup
  $(document).on('click.aiScoreTooltip', '.ai-score-badge[data-score-url]', function(e){
    e.preventDefault();
    var $badge = $(this);

    // Cache invalidation: the badge carries a data-score-version stamped from
    // screening_scored_at. When the applicant is re-scored and this page is
    // rerendered (e.g. Turbo Drive restoration or a partial refresh), the
    // stamp changes and we tear down the cached popover so the next click
    // re-fetches. Same page load with unchanged score = no re-fetch.
    var currentVersion = String($badge.attr('data-score-version') || '');
    var cachedVersion  = String($badge.data('popover-version') || '');
    if (currentVersion !== cachedVersion){
      var existing = window.bootstrap && window.bootstrap.Popover
                     ? window.bootstrap.Popover.getInstance($badge[0]) : null;
      if (existing) existing.dispose();
      $badge.removeData('popover-loaded');
    }

    if ($badge.data('popover-loaded')){
      $badge.popover('toggle');
      return;
    }

    $.getJSON($badge.data('score-url'), function(data){
      var band = scoreBand(data.score);
      var bandTag = band
        ? '<span class="tl-popover-band tl-popover-band-' + band + '">' + escapeHtml(bandLabel(band)) + '</span>'
        : '';
      var stale = $badge.hasClass('is-stale')
        ? '<div class="tl-popover-stale"><i class="fa-solid fa-triangle-exclamation me-1"></i>' +
          escapeHtml($badge.data('stale-hint') || 'JD was edited after this score. Consider re-scoring.') +
          '</div>'
        : '';
      var rationale = data.rationale
        ? '<p class="tl-popover-rationale">' + escapeHtml(data.rationale) + '</p>'
        : '<p class="tl-popover-rationale text-muted"><em>No rationale available.</em></p>';

      var html =
        '<div class="tl-popover-head"><strong>Score ' + escapeHtml(data.score) + '</strong>' + bandTag + '</div>' +
        rationale + stale +
        '<div class="tl-popover-meta"><span>' + escapeHtml(data.model || '—') + '</span><span>' + escapeHtml(data.scored_at || '—') + '</span></div>';

      $badge.popover({
        html: true,
        content: html,
        placement: 'right',
        trigger: 'manual',
        customClass: 'tl-ai-popover'
      }).popover('show');
      $badge.data('popover-loaded', true);
      $badge.data('popover-version', String($badge.attr('data-score-version') || ''));
    });
  });

  // Close popovers when clicking outside
  $(document).on('click.aiScoreTooltip', function(e){
    if (!$(e.target).closest('.ai-score-badge, .popover').length){
      $('.ai-score-badge').popover('hide');
    }
  });
}

$(document).ready(init);
export { init };
